import { inject, Injectable } from '@angular/core';
import { catchError, map, type Observable, of } from 'rxjs';
import { toDataResult, ToResult } from '@team23/ts-result';
import {
    FilterConfigService,
    type FilterDataResult,
    FilterDataStatus,
    MultiFilterModel,
} from '@ui/shared/util-filter';
import {
    CoreService,
} from '@ui/shared/util-api';
import type { ProjectListFilterKey } from '../../types/project-list-filters';

@Injectable({ providedIn: 'root' })
export class DistrictSelectFilterConfigService extends FilterConfigService<ProjectListFilterKey, CoreService> {

    constructor() {
        super(
            new MultiFilterModel('district', 'Stadtteil', []),
            inject(CoreService),
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return this._api.getAllDistricts({
            order: [],
        })
            .pipe(
                map(result =>
                    result.data.map(dto => ({
                        value: dto.id,
                        label: dto.name,
                    })),
                ),
                toDataResult(),
                catchError(() => of(ToResult.fromErrorKey(FilterDataStatus.Generic))),
            );
    }
}
